import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { CHANGE_SIDE_LABELS, HTML_CHANGE_TITLE } from '../../FormChangeHistory.constants';
import { TemplateSideLabelsPropType } from '../../FormChangeHistory.propTypes';
import { changesetStyles } from '../../FormChangeHistory.styles';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import { getHtmlChange } from '../../FormChangeHistory.utils';
import TemplateFileVersions from '../TemplateFileVersions';

/**
 * An HTML template's two sides: what happened to it and each side's facts. The files open, in a
 * sandboxed frame, from a change (`auditId`); a compare shows facts only.
 */
const HtmlTemplateFacts = ({
  html,
  auditId = null,
  sideLabels = CHANGE_SIDE_LABELS,
  titles = HTML_CHANGE_TITLE,
}) => (
  <Box data-testid={FormChangeHistoryTestIds.HTML_CHANGESET} sx={changesetStyles}>
    <Typography variant="medium14">{titles[getHtmlChange(html)]}</Typography>
    <TemplateFileVersions auditId={auditId} files={html} sideLabels={sideLabels} />
  </Box>
);

HtmlTemplateFacts.propTypes = {
  html: PropTypes.shape({ before: PropTypes.object, after: PropTypes.object }).isRequired,
  auditId: PropTypes.string,
  sideLabels: TemplateSideLabelsPropType,
  titles: PropTypes.objectOf(PropTypes.string),
};

export default HtmlTemplateFacts;
